<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="adress_modal_trriger">        
        <div class="adress-modal u-window">
            <div class="dialog-title t-adress"></div>
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="adress-form">
                        <div class="form-row"><p class="label">收 件 名 ：</p><input name="name" class="text-input" placeholder="请填写您的真实姓名" type="text"></div>
                        <div class="form-row"><p class="label">手机号码：</p><input name="phone" class="text-input" placeholder="请填写您的手机号" type="text"></div>
                        <div class="form-row"><p class="label">收货地址：</p><textarea name="address" class="text-input" placeholder="请填写您的收货地址"></textarea></div>
                    </div>
                    <p class="warn"><em class="icon i-warn"></em>为了防止个人信息泄露，填写信息后不可修改与查看，请谨慎填写个人信息。</p>
                    <p class="warn">因个人信息填写错误，导致的无法收到实物奖励，不做补发。</p>
                </div>
            </div>
            <div class="u-btn apply" @click="adressSubmit"></div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
import GLOBAL from '@/assets/js/global.js';

export default {
    name : 'adress-modal',
    data : function (){
        return {
            rules : {
                name : {
                    require : true,
                    reg : /^[\u4e00-\u9fa5]{2,8}$/,
                    info : '请填写正确的收件人姓名'
                },
                phone : {
                    require : true,
                    reg : /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
                    info : '请填写正确的收件人手机号'
                },
                address : {
                    require : true,
                    reg : /^[\u4e00-\u9fa50-9a-z]{2,100}$/i,
                    info : '请填写正确的收货地址'
                }
            }
        }
    },
    props : {
        adress_modal_trriger : {
            default : false
        }
    },    
    methods: {
        closeModal(){
            document.body.removeEventListener('touchmove',GLOBAL.bodyScroll,{ passive: false });
            this.$emit("modal_switch", 'adress_modal_trriger');
        },
        adressSubmit(){
            var _v = this;
            var _input = document.getElementsByClassName('text-input');
            var checkList = [];
            var data = {};
            for(var i=0;i < _input.length;i++){
                var el = _input[i];
                var val = el.value;
                var key = el.getAttribute('name');

                var boolean = val.match(_v.rules[key].reg);
                if(!boolean){
                    _v.$toast.info(_v.rules[key].info);
                    break;
                }
                checkList.push({
                    form_key : key,
                    form_val : val
                });
            }

            if(checkList.length < _input.length)return;
            //console.log(checkList);
            checkList.map(function(currentValue, index, arr){
                data[currentValue.form_key] = currentValue.form_val;
            });

            _v.$axios.post(GLOBAL.ajax_url_map.address + '?ver=' + GLOBAL.version,GLOBAL.param(data))
            .then(function(response){
                if(response.data.code == 0){
                    _v.closeModal();
                    _v.$toast.info('提交成功~');
                    _v.$emit("reward_update", 9);
                }
                else{
                    _v.$toast.info(response.data.message);
                }                
            });
        }
    },    
}
</script>

<style>
    .t-adress{
        width: 2.13rem;
        height: .57rem;
        margin: 0 auto .2rem;
        background-image: url(~@/assets/images/title-adress.png);
    }

    .adress-modal .dialog-content{
        position: relative;
        width: 7.18rem;
        height: 7.37rem;
        margin: 0 auto .55rem;
        background-image: url(~@/assets/images/bg-modal-adress.png);
    }

    .adress-modal .dialog-wrapper{
        padding: .7rem .7rem 0;
    }

    .adress-modal .u-btn.apply{
        width: 3.06rem;
        height: .89rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/btn-adress-apply.png);    
    }    

    .adress-modal .u-btn.close{
        position: absolute;
        top: -.6rem;
        right: .8rem;
    }

    .adress-modal .warn{
        margin-bottom: .15rem;
        line-height: 1.6;
        color: #fe2c2c;
    }

    .adress-form{
        margin-bottom: .3rem;
    }

    .adress-form .form-row{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: .2rem;
    }

    .adress-modal .adress-form .label{
        color: #a4752d;
    }

    .adress-form input,.adress-form textarea{
        display: inline-block;
        width: 4.3rem;
        height: .6rem;
        line-height: .6rem;
        color: #a4752d;
        background-color: #5c280d;
        border: none;
        text-align: center;
    }

    .adress-form textarea{
        height: 2.18rem;
        box-sizing: border-box;
        padding: .2rem .4rem;
        text-align: left;
        resize: none;
        outline:none;
    }

    .i-warn{
        display: inline-block;
        vertical-align: middle;
        width: .31rem;
        height: .27rem;
        margin-right: .15rem;
        background-image: url(~@/assets/images/icon-warn.png);
    }

</style>


// WEBPACK FOOTER //
// src/components/adressModal.vue